import { render, staticRenderFns } from "./ConversationMessageItem.vue?vue&type=template&id=2194bcd7"
import script from "./ConversationMessageItem.vue?vue&type=script&lang=js"
export * from "./ConversationMessageItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports